import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("bp-text-hebrew")
export class TextHebrew extends LitElement {
  static styles = css`
    :host {
      font-family: var(--font-hebrew);
      display: inline-block;
      font-weight: normal;
      direction: rtl;
    }
  `;

  render() {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-text-hebrew": TextHebrew;
  }
}
